<div id="successMessageId" class="successMessage">{{"CONTACT_US.SUCCESS_MESSAGE"|translate}}</div>
<div class="row contactUsContainer" [dir]="dir">
  <div class="col-md-6 col-sm-12">
    <h3 class="contancttTitle">{{"CONTACT_US.TITLE"|translate}}</h3>
    <p style="font-size: 17px;">{{"CONTACT_US.DESCRIPTION"|translate}}</p>
    <p><img src="./assets/images/undraw-contact.svg" alt="Image" class="img-fluid"></p>
  </div>
  <div class="col-md-6 col-sm-12">
    <form class="mb-5" method="post" id="contactForm" [formGroup]="contactUsForm">
      <div class="row">
        <mat-form-field class="col-sm-12" appearance="outline">
          <mat-label>{{ "CONTACT_US.YOUR_NAME" | translate }}</mat-label>
          <input matInput formControlName="name" required />
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-sm-12" appearance="outline">
          <mat-label>{{ "CONTACT_US.EMAIL" | translate }}</mat-label>
          <input matInput formControlName="email" required />
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-sm-12" appearance="outline">
          <mat-label>{{ "CONTACT_US.SUBJECT" | translate }}</mat-label>
          <input matInput formControlName="subject" required />
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-sm-12" appearance="outline">
          <mat-label>{{ "CONTACT_US.MESSAGE" | translate }}</mat-label>
          <input matInput formControlName="message" required />
        </mat-form-field>
      </div>
      <div class="row">
        <input type="submit" [value]="'CONTACT_US.SUBMIT'|translate" class="sendBtn" (click)="contanctUsAction()">
      </div>
    </form>
  </div>
</div>
